export const getUID = () => Math.floor(Math.random() * 1000000000);


// WEBPACK FOOTER //
// ./src/Services/Misc/id.js